import 'sanitize.css'
import 'sanitize.css/forms.css'
import 'sanitize.css/assets.css'
import 'sanitize.css/typography.css'
import 'sanitize.css/reduce-motion.css'
import 'prism-themes/themes/prism-xonokai'
import './style/index.css'
import { App } from './components/App'

export default App
